<template>
    <div class="carOwnerbox">
        <headerbox :focus="8"></headerbox>
        <div class="fixedcolor"></div>
        <img class="imgfont" src="../../public/statics/img/ycz2.png" alt="">
        <img class="imgcount" src="../../public/statics/img/ycz3.png" alt="">
    </div>

</template>

<script>

    import headerbox from "../components/boxtop";
    export default {
    name: "carOwner",
    data(){
        return{
        
        }
    },
        components: {
            headerbox: headerbox,
        },
    mounted(){},
    methods:{
        
    },
}
</script>

<style scoped lang='scss'>
    .carOwnerbox{
        width: 100%;
        height: 100vh;
        background-image: url('../../public/statics/img/ycz1.png');
        background-repeat: no-repeat;
        background-position: center;
        background-attachment: fixed;
        background-size: cover;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        .fixedcolor{
            width: 100%;
            height: 0.6rem;
            /*background: #2c3e50;*/
            position: fixed;
            top: 0;
        }
        .imgfont{
            width: 60%;
            height: auto;
            position: fixed;
            left: 0;
            right: 0;
            top: 23%;
        }
        .imgcount{
            width: 30%;
            height: auto;
            position: fixed;
            left: 0;
            right: 0;
            bottom:15%;
            margin: auto;
        }
    }

</style>